import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import {
  useFetchResponseCodesQuery,
} from 'api/dashboard'

import ChartContainer from 'components/Shared/charts/Chart'
import LoadingIndicator from 'components/Shared/LoadingIndicator/Index'

import { colorizeResponseCodes } from 'utils/color'

import cloneDeep from 'lodash/cloneDeep'

const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  border-radius: 3px;
  padding: 10px 16px 10px 16px;
  background-color: #FFFFFF;
`

const Title = styled.div`
  font-family: Exo;
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 10px;
  color: #353535;
`

const ChartWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`

const ResponseCodesChart = ({ ticketingSystemDisplayId, selectedTimeIntervalId, userTimeZoneAbbr, userTimeFormat24 }) => {
  const { t } = useTranslation()

  const { data, isFetching } =
    useFetchResponseCodesQuery({
      ticketingSystemDisplayId: ticketingSystemDisplayId,
      timeInterval: selectedTimeIntervalId,
    },
    {
      skip: !ticketingSystemDisplayId,
    })

  const responseCodes = data?.responseCodes || []

  const chartConfig = {
    type: 'area',
    displayTimezone: userTimeZoneAbbr,
    timeFormat24: userTimeFormat24,
  }

  if (!responseCodes) {
    return null
  }

  let responseCodesData = cloneDeep(responseCodes)

  responseCodesData = colorizeResponseCodes(responseCodesData)

  return (
    <StyledWrapper data-test='response-codes-chart'>
      <LoadingIndicator loading={isFetching} small />
      <Title>{t('dashboardPage.responseCodesChart')}</Title>
      <ChartWrapper>
        <ChartContainer config={chartConfig} data={responseCodesData} />
      </ChartWrapper>
    </StyledWrapper>
  )
}

ResponseCodesChart.propTypes = {
  ticketingSystemDisplayId: PropTypes.string,
  selectedTimeIntervalId: PropTypes.string,
  userTimeZoneAbbr: PropTypes.string,
  userTimeFormat24: PropTypes.bool,
}

export default ResponseCodesChart
